import { render, staticRenderFns } from "./carouselA.vue?vue&type=template&id=75b8e316&scoped=true&"
import script from "./carouselA.vue?vue&type=script&lang=js&"
export * from "./carouselA.vue?vue&type=script&lang=js&"
import style0 from "./carouselA.vue?vue&type=style&index=0&id=75b8e316&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b8e316",
  null
  
)

export default component.exports